import React, {Component, Fragment} from 'react';
import {NavLink} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {logout} from 'apa/actions';

class Login extends Component {
    render() {
        return (
            <li className="nav-item">
                <NavLink to="/login" className="nav-link">
                    Login
                </NavLink>
            </li>

        )
    }
}

class Signup extends Component {
    render() {
        return (
            <li className="nav-item">
                <NavLink to="/signup" className="nav-link">
                    Registrierung
                </NavLink>
            </li>

        )
    }
}

class Logout extends Component {
    render() {
        const { user, logout } = this.props;

        if (user.access_code) {

            var user_additional_information = user.access_code.training.access_codes.filter(function (item) {

                if (item['id'] === undefined || item['id'] != user.access_code.id)
                    return false;

                return true;
            });
        }

        return (
            <Fragment>
            <li className="nav-item">
                <a className="nav-link">
                {user.access_code ? user_additional_information[0].additionalinformation.name : user.username}
                { (user.access_code && user_additional_information[0].additionalinformation.name && user_additional_information[0].additionalinformation.phone_num) ? " - " : "" }
                {user.access_code ? user_additional_information[0].additionalinformation.phone_num : ""}
                </a>
            </li>
            <li className="nav-item">
                <a onClick={logout} href="#" className="nav-link">
                    Logout
                </a>
            </li>
        </Fragment>
        )
    }
}

class AnonNavigation extends Component {
    render() {
        return (
            <ul className="navbar-nav mr-auto"></ul>
        )
    }
}

class UserNavigation extends Component {
    render() {
            return <ul className="navbar-nav mr-auto"></ul>
    }
}

class SuperUserNavigation extends Component {
    render() {
        return (
            <ul className="navbar-nav mr-auto">
            <li className="nav-item">
                <NavLink className="nav-link" to='/customer' exact>
                    Kunden
                </NavLink>
            </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to='/catalog' exact>
                        Katalog
                    </NavLink>
                </li>
            <li className="nav-item">
                <NavLink className="nav-link" to='/training/overview' exact>
                    Schulungen
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to='/manuals' exact>
                    Betriebsanweisungen
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to='/template' exact>
                    Mustervorlagen
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink className="nav-link" to='/training' exact>
                    Fragenkatalog
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink activeClassName={'active'} className="nav-link" to='/items' exact>
                    Buchführung
                </NavLink>
            </li>
            <li className="nav-item">
                <NavLink activeClassName={'active'} className="nav-link" to='/invoices' exact>
                    Rechnungen
                </NavLink>
            </li>
        </ul>
        )
    }
}

@connect(
    state => {
        return {
            isSuperUser: state.apa.isSuperUser,
            isAuthenticated: state.apa.isAuthenticated,
            isLoading: state.apa.isLoading,
            user: state.apa.user
        }
    },
    dispatch => {
        return {
            logout: () => dispatch(logout()),
        }
    }
)
export default class Navigation extends Component {

    render() {

        const {
            isLoading,
            isAuthenticated,
            isSuperUser,
            user,
            logout
        } = this.props;


        const Navi = isSuperUser ? SuperUserNavigation : UserNavigation;

        const MainNavigation = isAuthenticated ? Navi : AnonNavigation;

        if (isLoading) {
            return <nav className="navbar navbar-expand-lg navbar-light bg-light">
                Loading
            </nav>
        }

        const LoginLogout = isAuthenticated ? <Logout user={user} logout={logout} /> :
            <Fragment>
                <Login />
                <Signup />
            </Fragment>

        return <nav className="navbar navbar-expand-lg navbar-light bg-light">
            {isSuperUser ? (
                <a className="navbar-brand" href='/customer'>
                    APA
                </a>
            ):(
            <a className="navbar-brand" href='/training/welcome'>
                APA
            </a>
            )}
            <button className="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"> </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <MainNavigation/>
                <ul className="navbar-nav">
                    { LoginLogout }
                </ul>
            </div>
        </nav>
    }
}

Navigation.propTypes = {
    isAuthenticated: PropTypes.bool,
    isLoading: PropTypes.bool,
    user: PropTypes.object,
    logout: PropTypes.func
}
